import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { getAllPoets } from '../../services/poetsService';
import bg1 from '../../assets/images/b2.png'


export default class Poets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            poets: getAllPoets()
        };
    }

    componentDidMount() {

    }

    render() {
        return (
            <div>
                <div className="pageHeader" style={{ backgroundImage: `url(${bg1})` }}>
                    <h1>Poets</h1>
                </div>
                {this.state.poets.map((poet) => {
                    return <div className="poet">
                        <img style={{ maxWidth: '20%' }} src={`https://ptbo-assets.s3.eu-west-1.amazonaws.com/images/${poet.image}`} alt="" />
                        <Row><h2>{poet.name}</h2></Row>
                        {<p>{poet.bio}</p>}
                        <br/>
                    </div>
                })
                }

            </div >
        );
    }
}
